import mutations from './mutations'
import actions from './actions'
import getters from './getters'

export default {
  namespaced: false,
  state: {
    financialYears: null,
    authorisation: {},
    /** Optimistic default; do not surface UI until authorisationStatusKnown. */
    swiftaidAuthorised: true,
    /** False until GET /me/authorisation has settled at least once. */
    authorisationStatusKnown: false,
    userDetails: {
      accounts: [],
    },
    banks: [],
    bank: null,
    statements: null,
    /** GET /me/statements/years: { years, hasHistoricYears }; null until loaded. */
    statementYears: null,
    referralLink: null,
    /** True when POST /me returns 409: the donor account is scheduled for deletion. */
    scheduledForDeletion: false,
    /** 'free' | 'paid', populated from API when Swiftaid Giving subscription exists. */
    swiftaidGivingPlan: 'free',
    /** False until GET /me/plan has settled at least once. */
    donorPlanStatusKnown: false,
    /** Subscription summary from GET /me/plan (status, productId, renewsAt); null when free. */
    swiftaidGivingSubscription: null,
    /** Plan feature flags from GET /me/plan (e.g. fullGivingRecord); null until loaded. */
    swiftaidGivingFeatures: null,
  },
  mutations,
  actions,
  getters,
}
